var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.status === 401 || _vm.status === 403)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('unauthorized'))+" ")]):_vm._e(),(_vm.status === 404)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('notfound'))+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('unknownerror'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }